module.exports = __webpack_public_path__ + "static/gp_white-d4e6f48a63008fcaa33ca5ec07d45a48.png";